export default {
    preview: '预览前台',
    logo_text: '美迪康会务通',
    exit: '安全退出',
    submit: '立即提交',
    placeholder: '请输入',
    search: '搜索',
    reset: '重置',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    operation: '操作',
    please_select: '请选择',
    please_enter: '请输入',
    please_upload: '请上传',
    serial_number: '序号',
    yes: '是',
    no: '否',
    operation_success: '操作成功',
    positive_integer: '正整数',
    prev_step: '上一步',
    next_step: '下一步',
    cancel: '取消',
    show: '显示',
    not_show: '不显示',
    upload_image: '上传图片',
    clear: '清 除',
    success: '成功',
    fail: '失败',
    save: '保存',
    male: '男',
    female: '女',
    close: '关闭',
    required_null: '必填项不能为空',
    export: '导出',
    details: '详情'
};
